import React from "react";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";

const parseScoreCsv = (scoresCsv) => {
  const sets = scoresCsv?.split(",") || [];

  return sets.map((set) => {
    const [p1, p2] = set.split("-").map((s) => parseInt(s.trim(), 10));
    return { p1, p2 };
  });
};

const MatchScoreTable = ({ match }) => {
  const scores = parseScoreCsv(match.scores_csv);
  const player1 = match.participants?.[0];
  const player2 = match.participants?.[1];

  const isPlayer1Winner = match.winner_id === player1?.id;
  const isPlayer2Winner = match.winner_id === player2?.id;

  return (
    <Table size="small">
      <TableBody>
        <TableRow>
          <TableCell sx={{ fontWeight: isPlayer1Winner ? "bold" : "normal" }}>
            {player1?.name ?? player1?.placeholder ?? "Jugador 1"}
          </TableCell>
          {scores.map((set, idx) => (
            <TableCell key={idx} align="center" sx={{ fontWeight: isPlayer1Winner ? "bold" : "normal" }}>
              {set.p1}
            </TableCell>
          ))}
        </TableRow>
        <TableRow>
          <TableCell sx={{ fontWeight: isPlayer2Winner ? "bold" : "normal" }}>
            {player2?.name ?? player2?.placeholder ?? "Jugador 2"}
          </TableCell>
          {scores.map((set, idx) => (
            <TableCell key={idx} align="center" sx={{ fontWeight: isPlayer2Winner ? "bold" : "normal" }}>
              {set.p2}
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default MatchScoreTable;
